<script>
  import { onMount, afterUpdate } from "svelte";
  import { Button, ButtonToolbar } from "sveltestrap";
  import { _ } from '../i18n.js';

  export let buttonLabels;
  export let current = "";
  export let selectChart;

  // onMount(() => {
  //   if (current === "") {
  //     current = firstSelected;
  //   }
  // });
</script>
<ButtonToolbar class="d-flex justify-content-center">
  {#each buttonLabels as button}
  <div class="{"toolbar"}">
    <Button
        color="primary"
      id={button}
      on:click={selectChart}
      active={current === button}
      disabled={current === button}
      >{$_(button)}</Button>
    </div>
      {/each}
  
</ButtonToolbar>



<style>
    .toolbar {
        margin: .2rem;
    }
</style>
